import http from "../axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";

export interface GeneralDocument {
  id: number;
  judul: string;
  keterangan: string;
  file: string;
  created_at: string;
  url?: string;
  link?: string;
  aktif?: number | string;
  kategori?: string;
  fileName?: string;
  user?: string;
}

export interface PanduanSearchParams {
  search?: string | null;
  scope?: "all" | "aktif" | "inaktif";
}

// Get List
async function getGeneralDocumentList(
  params?: PanduanSearchParams
): Promise<GeneralDocument[]> {
  const response = await http
    .getDataParam(`/generaldocument`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  const data = response.data || [];

  return (data as GeneralDocument[]).map(p => ({
    id: p.id ?? 0,
    judul: p.judul || "",
    keterangan: p.keterangan || "",
    file: p.file ? p.file : "",
    url: p.url ? `${p.url}` : "",
    link: p.link ? `${p.link}` : "",
    created_at: p.created_at || "",
    aktif: p.aktif || "",
    kategori: p.kategori || "",
    fileName: typeof p.file === "string" ? p.file.split("/").pop() || "" : "",
    user: p.user ?? ""
  }));
}

// Get Detail
async function getGeneralDocumentById(id: number): Promise<GeneralDocument> {
  const response = await http.getData(`/generaldocument/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  const p = response.data.data;
  return {
    id: p.id,
    judul: p.judul,
    keterangan: p.keterangan,
    file: p.file,
    created_at: p.tgl,
    aktif: p.aktif,
    url: p.url,
    link: p.link,
    kategori: p.kategori
  };
}

// Create
async function createGeneralDocument(data: FormData) {
  const response = await http.postData(`/generaldocument`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

async function updateGeneralDocument(id: number, data: FormData) {
  data.append("_method", "PUT"); // penting untuk Laravel file upload

  const response = await http
    .postData(`/generaldocument/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

// Delete
async function deleteGeneralDocument(id: number) {
  const response = await http
    .deleteData(`/generaldocument/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

export default {
  getGeneralDocumentList,
  // getPanduanDrawer,
  getGeneralDocumentById,
  createGeneralDocument,
  updateGeneralDocument,
  deleteGeneralDocument
};
